import styled from 'styled-components';

export const Form = styled.div`
    padding: ${p => p.padding ?? '0 50px'};
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${p => p.align ?? 'center'};
    justify-content: ${p => p.align ?? 'stretch'};
    margin-bottom: 10px;
`;

export const Button = styled.div`
    height: 30px;
    border: 1px solid ${p => p.color ?? '#999'};
    color: ${p => p.color ?? '#999'};
    cursor: pointer;
    padding: 0 10px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    transition: all .4s ease 0s;

    &:hover {
        background-color: ${p => p.color ?? '#999'};
        color: #fff;
    }
`;

export const Image = styled.div`
    position: relative;
    width: 100px;
    height: 100px;
    background-color: #111;
    border: 1px solid #999;
    cursor: pointer;
    margin-right: 20px;
`;

export const ImageIcon = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    &:before {
        font-family: 'Material Design Icons';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 50px;
        color: #555;
        content: '\\F02EB';
    }
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${p => p.align ?? 'stretch'};
    justify-content: ${p => p.align ?? 'flex-start'};

    &.tag-column {
        flex: 3;
        margin-left: 10px;
    }
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    margin: 0 10px 10px 0;

    &.noBottom {
        margin-bottom: 0;
    }

    &.noRight {
        margin-right: 0;
    }
`;

export const Label = styled.div`
    font-size: 14px;
    color: #999;
    margin-bottom: 5px;
`;

export const Value = styled.div`
    font-size: 14px;
    color: #fff;
`;

export const NoValue = styled.div`
    font-size: 14px;
    color: #777;
`;

export const Date = styled.div`
    border: 1px solid #999;
    box-sizing: border-box;
    background-color: #111;
    color: #fff;
    width: 100%;
`;

export const Input = styled.input`
    border: 1px solid #999;
    height: 25px;
    padding: 0 5px;
    box-sizing: border-box;
    background-color: #111;
    color: #fff;
    min-width: 0;
    max-width: 100%;
`;

export const Select = styled.select`
    border: 1px solid #999;
    height: 25px;
    padding: 0 5px;
    box-sizing: border-box;
    background-color: #111;
    color: #fff;
    min-width: 0;
    max-width: 100%;
`;

export const TextArea = styled.textarea`
    border: 1px solid #999;
    min-height: 120px;
    flex: 1;
    padding: 5px;
    box-sizing: border-box;
    background-color: #111;
    color: #fff;
    resize: none;
`;

export const Error = styled.div`
    border: 1px solid #d00;
    color: #aaa;
    min-height: 40px;
    width: 100%;
    padding: 0 0 0 30px;
    box-sizing: border-box;
    background-color: #600;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    font-size: 14px;
    margin-bottom: 20px;

    &:before {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 35px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        content: '\\F0026';
        color: #b00;
        font-size: 20px;
        font-family: "Material Design Icons";
    }
`;
